export default __webpack_public_path__ + "static/media/xun.e9f086e8.png";